import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_PILL_CLICKED_OBJECTS = ['asset', 'asset_list', 'board', 'comment'] as const;

export type WorkspaceAgentPillClickedObject = (typeof WORKSPACE_AGENT_PILL_CLICKED_OBJECTS)[number];

const META: Meta = {
  description: 'The user clicks an agent pill chip to open its preview or subject',
  name: 'agent_pill_clicked',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The type of object the pill represents',
      name: 'object',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_PILL_CLICKED_OBJECTS],
    },
    {
      description: 'The number of objects represented by the pill',
      name: 'object_count',
      required: true,
      type: 'number',
    },
    {
      description: 'The display label of the pill at click time',
      name: 'object_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
